import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx'; // import Button from '@/components/Button';

// import SubNav, { Option } from '@/components/navigation/SubNav';
import StyleVariables, { getSectionAttr, getSectionAttrSelector } from '../../../../misc/StyleVariables';
import settings from './settings';
import styles from './styles.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const LayoutHeader = _ref => {
  let {
    widgetId,
    heading,
    subHeading,
    // ctaPrompt,
    // ctaButton,
    // ctaButtonColor,
    // onCtaClick,
    // isCtaThresholdMet,
    // sections,
    className = '',
    classes = {},
    isMediumContainer,
    isLargeContainer
  } = _ref;

  // const sectionNavOptions = sections
  //   .filter(
  //     ({ elementId, config }) =>
  //       Boolean(elementId) && Boolean(config.displayName)
  //   )
  //   .map(
  //     (section) =>
  //       ({
  //         name: section.config.displayName,
  //         targetId: section.elementId,
  //       } as Option)
  //   );
  // const showSectionNav =
  //   !isMediumContainer && !isLargeContainer && sectionNavOptions.length > 1;
  // let ctaButtonStyles = '';
  // if (ctaButtonColor) {
  //   ctaButtonStyles += `background-color: ${ctaButtonColor} !important; border-color: ${ctaButtonColor} !important;`;
  // }
  // Remove header if there's nothing to render
  if (!heading
  /*&& !showSectionNav*/
  ) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsxs("header", _objectSpread(_objectSpread({
    className: clsx(styles.container, isMediumContainer ? styles['container--twoColumns'] : '', isLargeContainer ? styles['container--threeColumns'] : '', className)
  }, getSectionAttr(widgetId, 'section-header')), {}, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: clsx(styles.main, classes === null || classes === void 0 ? void 0 : classes.main),
      children: [heading ? /*#__PURE__*/_jsx("h5", {
        className: clsx(styles.main__heading, styles['main__heading--h4'], classes === null || classes === void 0 ? void 0 : classes.heading),
        children: heading
      }) : /*#__PURE__*/_jsx(_Fragment, {}), subHeading ? /*#__PURE__*/_jsx("p", {
        className: clsx(styles.main__subheading, classes === null || classes === void 0 ? void 0 : classes.subheading),
        children: subHeading
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }), /*#__PURE__*/_jsx(StyleVariables, {
      selector: getSectionAttrSelector(widgetId, 'section-header'),
      data: _objectSpread({}, settings.styles)
    })]
  }));
};

export default LayoutHeader;